import React from "react";
import { EmailModal } from "@/components/EmailModal/EmailModal";
import { SuccessModal } from "@/components/SuccessModal/SuccessModal";
import { AppLoginScreen } from "@/features/AppLogin/AppLoginScreen";
import { InstructionScreen } from "@/features/InstructionScreen/InstructionScreen";
import { PaymentMethodsScreen } from "@/features/PaymentMethodsScreen/PaymentMethodsScreen";
import { getAppLoginParam } from "@/utils/startParam";
import { MainScreen } from "./components/MainScreen";
import {
  MainActionsProvider,
  MainScreenProvider,
  MainSubscriptionProvider,
  useMainActionsContext,
  useMainScreenContext,
  useMainSubscriptionContext,
} from "./MainPageContext";

function MainPageContent() {
  const { screen, setScreen } = useMainScreenContext();
  const {
    paymentMethods,
    successOpen,
    closeSuccess,
  } = useMainSubscriptionContext();
  const {
    isCardLoading,
    selectingPaymentMethodId,
    deletingPaymentMethodId,
    paymentMethodsError,
    emailModalOpen,
    closeEmailModal,
    onAddCard,
    onEmailSubmit,
    onSelectCard,
    onDeleteCard,
  } = useMainActionsContext();

  if (screen === "app-login") {
    return (
      <AppLoginScreen
        initialCode={getAppLoginParam()?.code ?? ""}
        onClose={() => setScreen("main")}
      />
    );
  }

  if (screen === "instructions") {
    return <InstructionScreen onBack={() => setScreen("main")} />;
  }

  if (screen === "payment-methods") {
    return (
      <PaymentMethodsScreen
        paymentMethods={paymentMethods}
        onBack={() => setScreen("main")}
        onAddCard={onAddCard}
        onSelectCard={onSelectCard}
        onDeleteCard={onDeleteCard}
        isCardLoading={isCardLoading}
        selectingPaymentMethodId={selectingPaymentMethodId}
        deletingPaymentMethodId={deletingPaymentMethodId}
        error={paymentMethodsError}
      />
    );
  }

  return (
    <>
      <MainScreen />
      <SuccessModal isOpen={successOpen} onClose={closeSuccess} />
      <EmailModal
        isOpen={emailModalOpen}
        onClose={closeEmailModal}
        onSubmit={onEmailSubmit}
      />
    </>
  );
}

export default function MainPage() {
  return (
    <MainScreenProvider>
      <MainSubscriptionProvider>
        <MainActionsProvider>
          <MainPageContent />
        </MainActionsProvider>
      </MainSubscriptionProvider>
    </MainScreenProvider>
  );
}
